import { Route } from '@angular/router';
import { IsLoggedInGuard } from '@lexplus-authentication';
import { LOCALIZED_SHARED_ROUTES, SHARED_ROUTE_IDS } from '@lexplus-shared-lib';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../../localized-user-routes-const';
import { UserDetailDrawerRoute } from '../../../global/functions/user-detail-drawer-route.function';
import { newsletterOnlyRedirectGuard } from '../../../global/functions/newsletter-only-redirect.guard';

export function DashboardPageRoute(localeId: string): Route {
  const locale = localeId?.split('-')[0] || 'en';

  return {
    path: LOCALIZED_SHARED_ROUTES[SHARED_ROUTE_IDS.DASHBOARD][locale],
    canActivate: [IsLoggedInGuard, newsletterOnlyRedirectGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./dashboard-page/dashboard-page.component').then((m) => m.DashboardPageComponent),
        data: { routeId: SHARED_ROUTE_IDS.DASHBOARD },
        // The detail drawers this page links to, on their feature's segment rather than
        // «details». Each keeps its own permission guard.
        children: [
          UserDetailDrawerRoute('aufgabe', LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_TASKS][locale], SHARED_ROUTE_IDS.DASHBOARD, locale),
          UserDetailDrawerRoute(
            'dokument',
            LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_DOCUMENT_MANAGER][locale],
            SHARED_ROUTE_IDS.DASHBOARD,
            locale,
          ),
          UserDetailDrawerRoute(
            'anforderung',
            LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_COMPLIANCE_OVERVIEW][locale],
            SHARED_ROUTE_IDS.DASHBOARD,
            locale,
          ),
        ],
      },
    ],
  };
}
